import React from 'react';
import {observer} from 'mobx-react';
import classNames from 'classnames';
import styles from '../style/slider.module.scss';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";

export class SliderCardProps extends BaseProps {
  isDiagonal: Boolean;
  isFirst: Boolean;
}

export const SliderCard = observer(({isFirst, isLast, children, className}: SliderCardProps) => {
  return (
    <div className={classNames(styles.slider_card_content_shape, {[styles.first]: isFirst}, {[styles.last]: isLast}, className)}>
      {
        children
      }
    </div>
  )
});
